import React from "react";
import { iconMap } from "../utilities/utilities";

const ScrollableListOfFiles = (props) => (
	<div
		className="GreyContainer"
		style={{
			marginTop: 10,
			maxHeight: 300,
			maxWidth: "100%",
			overflow: "auto",
		}}
	>
		{props.documentList.map((documentName, index) => {
			const { iconComponent } = iconMap({
				original: {
					type: "File",
					filename: documentName,
				},
			});
			return (
				<div
					className="shareFileListItem"
					key={index}
					style={{ lineHeight: "2em" }}
				>
					{iconComponent ? iconComponent : null}
					<span>{documentName}</span>
				</div>
			);
		})}
	</div>
);
export default ScrollableListOfFiles;
